var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconView02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M9.818 8.095a1.818 1.818 0 1 1-3.636 0 1.818 1.818 0 0 1 3.636 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M.727 8.125s2.728-5 7.273-5c4.546 0 7.273 5 7.273 5s-2.727 5-7.273 5-7.273-5-7.273-5M8 11.307a3.182 3.182 0 1 0 0-6.364 3.182 3.182 0 0 0 0 6.364"
})));
export default SvgIconView02;